import {Button} from '@chekinapp/ui';
import {closeSession} from 'components/sessions/utils';
import {useTranslation} from 'react-i18next';
import {useReservation} from 'context/reservation';
import {LogOut} from 'lucide-react';

function ExitReservationButton() {
  const {t} = useTranslation('kiosko');
  const {reservationId} = useReservation();

  const handleExit = () => {
    closeSession(reservationId);
  };

  return (
    <Button
      variant="outline"
      onClick={handleExit}
      className="!w-full text-kiosko-m h-[112px] !border-[2px] !rounded-[56px] flex gap-5 mt-[56px]"
    >
      <LogOut size={48} />
      {t('exit_reservation')}
    </Button>
  );
}

export {ExitReservationButton};
